import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import * as Type from "./type";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { putSaga } from "src/request/put";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { deleteSaga } from "src/request/delete";

//***CONTRACT SOURCES***//
export const getContractSources = createAction(
  "GET_CONTRACT_SOURCES",
  ({ payload, params }: SagaActionParams<Type.ContractSourceDto[]>) => ({
    payload,
    url: "/api/admin/contractsource" + (params ? params : ""),
  })
);
export const getContractSourceDetails = createAction(
  "GET_CONTRACT_SOURCES_DETAILS",
  ({ payload, id }: SagaActionParams<Type.ContractSourceDetailDto>) => ({
    payload,
    url: "/api/admin/contractsource/" + id,
  })
);
export const createContractSource = createAction(
  "CREATE_CONTRACT_SOURCES",
  ({ payload, body }: SagaActionParams<Type.ContractSourceDto>) => ({
    payload,
    url: "/api/admin/contractsource",
    body,
  })
);
export const updateContractSource = createAction(
  "UPDATE_CONTRACTSOURCES",
  ({ payload, id, body }: SagaActionParams<Type.ContractSourceDto>) => ({
    payload,
    url: "/api/admin/contractsource/" + id,
    body,
  })
);
export const deleteContractSource = createAction(
  "DELETE_CONTRACT_SOURCES",
  ({ payload, id }: SagaActionParams<Type.ContractSourceDto>) => ({
    payload,
    url: "/api/admin/contractsource/" + id,
  })
);

const contractSourceSaga = [
  /****************CONTRACTSOURCESS****************/
  takeLatest<any>(
    getContractSources.toString(),
    (payload: SagaGenericParams<Type.ContractSourceDto[]>) =>
      getSaga<Type.ContractSourceDto[]>(payload)
  ),
  takeLatest<any>(
    getContractSourceDetails.toString(),
    (payload: SagaGenericParams<Type.ContractSourceDetailDto>) =>
      getSaga<Type.ContractSourceDetailDto>(payload)
  ),
  takeLatest<any>(
    createContractSource.toString(),
    (payload: SagaGenericParams<Type.ContractSourceDetailDto>) =>
      postSaga<Type.ContractSourceDetailDto>(payload)
  ),
  takeLatest<any>(
    updateContractSource.toString(),
    (payload: SagaGenericParams<Type.ContractSourceDetailDto>) =>
      putSaga<Type.ContractSourceDetailDto>(payload)
  ),
  takeLatest<any>(
    deleteContractSource.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.ContractSourceDetailDto>(payload)
  ),
];

export default contractSourceSaga;
